export function formatCurrency(amount, currency = 'EUR', position = 'right') {
  const value = new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(amount || 0)
  // Intl place la devise selon locale; on force position via remplacement simple
  const symbol = new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).formatToParts(0).find(p => p.type==='currency')?.value || '€'
  const number = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0)
  return position === 'left' ? `${symbol} ${number}` : `${number} ${symbol}`
}

